<template>
  <div class="withdrawal">
    <div class="line-box">
      <div class="line-identity">
        <div class="panel">
          <template v-if="true">
            <span class="title">提现金额</span>
            <div class="number">
              <span class="input">￥
                <van-field  
                  v-model="amount" 
                  :maxlength="8" 
                  class="inputVal" 
                  autofocus 
                  type="number" 
                  @blur="checkFeeValid"
                />
              </span>
            </div>
            <div class="tips" v-html="text"></div>
          </template>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="button bgd" @click="$router.go(-1)">返回</div>
      <div class="button" @click="confirmWithdrawal">确认提现</div>
    </div>
    <popup type="withdrawal" ref="popupRef" :amount="amount"/>
  </div>
</template>

<script>
import popup from './compoents/popup.vue'
import { round2Places } from "@/utils/utils";
const md5 = require('md5');
export default {
  components: {
    popup
  },
  computed: {
    is365() {
      return this.$cache.is365()
    }
  },
  data() {
    return {
      amount: 0,
      quotaDetail: {},
      userInfo: {},
      text: ""
    };
  },
  mounted() {
    this.availableWithdrawalInfo()
    this.queryPublicityData()
    this.getBindingInfo()
  },
  methods: {
    availableWithdrawalInfo() {
      this.$api.withdrawal.availableWithdrawalInfo().then(res => {
        if (res.data) {
          this.quotaDetail = res.data
          this.amount = this.quotaDetail.everyTimeMaxAmount
          console.log( this.quotaDetail)
        }
      })
    },
    queryPublicityData() {
      this.$api.h5.queryPublicityData('customer_withdraw_describe')
        .then(res => {
          this.text = res.data.order_text
        })
    },
    confirmWithdrawal() {
      if ( this.amount > this.quotaDetail.everyTimeMaxAmount ) {
        this.$toast(`本次最多可提现：${this.quotaDetail.everyTimeMaxAmount}元`)
      }else if (this.amount < 0.3) {
        this.$toast('提现金额不能小于0.3元')
      }else {
        this.$dialog.confirm({
          title: '提示',
          message: `正在进行提现操作！<br />请确认本次提现金额：${this.amount}元`,
        })
          .then(() => {
            this.applyWithdrawal()
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    // 提现请求
    applyWithdrawal() {
      let parmes = {
        flag: this.is365 ? 2 : 1,
        amount: this.amount,
        phoneNumber: this.userInfo.phone,
        code: ''
      }
      parmes.sign = md5(`phoneNumber:${parmes.phoneNumber},code:${parmes.code},amount${this.amount}s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      this.$api.withdrawal.applyWithdrawal(parmes)
        .then(res => {
          if (res.data) {
            this.$toast('提现申请成功,款项将在24小时内转账至微信零钱！')
            this.$router.go(-1)
          }
        }).catch(err => {})
    },
    checkFeeValid() {
      const { everyTimeMaxAmount,oldWalletAvailableVO = null } = this.quotaDetail
      this.amount = round2Places(this.amount)
      if (this.amount > everyTimeMaxAmount) return
      let totalSumDif = ((everyTimeMaxAmount * 100) - (this.amount * 100)) / 100
      let oldSumDif = ((oldWalletAvailableVO.walletBalance * 100) - (this.amount * 100)) / 100

      if (totalSumDif < 0.3) {
        this.amount =((this.amount * 100) + (totalSumDif *100)) / 100
      } else if ( (oldWalletAvailableVO.walletBalance > this.amount) && oldSumDif < 0.3) {
        this.amount =((this.amount * 100) + (oldSumDif *100)) / 100
      }
      
    },
    // 获取经销商信息
    getBindingInfo() {
      return this.$api.withdrawal.getBindingInfo()
        .then(res => {
          this.userInfo = res.data
        })
    },
  }
};
</script>

<style lang="stylus" scoped>
.withdrawal {
  height: 100vh;
  background: #F4F4F4;
  overflow hidden
  .line-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 47px;
    background: #FEF3E6;
    border-radius: 8px;
    .line-identity {
      width: 353px;
      height: 27px;
      background: #FF712D;
      box-shadow: inset 0px 1px 6px 0px #CC641E;
      border-radius: 8px;
      .panel {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 325px;
        // height: 392px;
        padding: 40px 0;
        margin: auto;
        margin-top: 14px;
        background: linear-gradient(180deg, #FEF3E6 0%, #FFFEFF 100%);
        .title {
          color: #333333;
          font-size: 15px;
          font-weight: 400;
        }
        .number {
          color: #FF6B31;
          font-size: 44px;
          font-weight: bold;
          margin-top: 20px;
          display: flex
          text-align: center
          .input {
            display: flex;
            align-items: center
            justify-content: center;
            font-size: 23px;
            .inputVal  {
              font-size: 24px;
              width 45%
              border: none
              background: none
              -webkit-text-fill-color:  #FF6B31;
            }
          }
    
        }
        .tips {
          padding: 0 10px;
          color: #999999;
          font-size: 11px;
          margin-top: 18px;
          line-height 20px;
        }
        p {
          color: #999999;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 84px;
    background: #FFFFFF;
    box-shadow: 0px -3px 9px 0px rgba(220, 220, 220, 0.3);
    .button {
      width: 138px;
      height: 43px;
      font-size: 17px;
      color: #FF6B31;
      text-align: center;
      line-height: 43px;
      border-radius: 8px;
      border: 1px solid #FF6B31;
      margin-top: 10px;
    }
    .bgd {
      color: #FFFFFF;
      background: #FF6B31;
    }
  }
}
 
</style>
